import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=19710b2e&scoped=true"
import script from "./SubMenu.vue?vue&type=script&lang=ts"
export * from "./SubMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19710b2e",
  null
  
)

export default component.exports